import React, { useEffect, useState } from "react";
import { SelectPicker } from "../../../../../components";
import useSimulatorSelect from "./SimulatorSelect.hooks";

export default function SimulatorSelect({
  onChange,
  simulationType,
  subscriptionType,
}) {
  const { state, handler } = useSimulatorSelect({
    simulationType,
    onChange,
    subscriptionType,
  });
  return (
    <div className="dropdown">
      <SelectPicker
        values={state.currentValues}
        withId
        onChange={(id) => {
          handler.onSelectChange(id);
          onChange({ id, type: simulationType });
        }}
        selectedLabelStyle={{
          marginLeft: 15,
          padding: 5,
          background: "#fff",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          borderRadius: 10,
        }}
        labelsStyle={{ left: 15, width: "max-content" }}
        id={
          state.simulationType == "by_user"
            ? state.selectedByUser.id
            : state.selectedByCredits.id
        }
        staticLabel={
          simulationType == "by_user"
            ? state.selectedByUser.name
            : state.selectedByCredits.name
        }
        doCloseOnSelect={true}
      />
    </div>
  );
}
